import styled from 'styled-components';

export const UnregisteredStep5Style = styled.div`
  .mb-15px {
    margin-bottom: 15px;
  }
`;
